import React, { createContext, useContext, useMemo } from 'react';
import { getCityByHostname } from '../config/cities';

const CityContext = createContext(null);

export const CityProvider = ({ children }) => {
  const city = useMemo(() => {
    const hostname = window.location.hostname;
    return getCityByHostname(hostname);
  }, []);

  const value = useMemo(() => ({
    city,
    citySlug: city.slug
  }), [city]);

  return (
    <CityContext.Provider value={value}>
      {children}
    </CityContext.Provider>
  );
};

export const useCityContext = () => {
  const context = useContext(CityContext);
  if (!context) {
    throw new Error('useCityContext must be used within a CityProvider');
  }
  return context;
};

export default CityContext;
